import { render, staticRenderFns } from "./teacherTag.vue?vue&type=template&id=77b71068&"
import script from "./teacherTag.vue?vue&type=script&lang=js&"
export * from "./teacherTag.vue?vue&type=script&lang=js&"
import style0 from "./teacherTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports